module.exports = __webpack_public_path__ + "static/media/master_promotion_01.a3c82916.gif";